import { useMemo } from 'react';

const DEFAULT_ANONYMOUS_NAME: string = 'Anonymous';

export const useAbbrName = (firstName: string, lastName: string): string => {
	return useMemo(() => {
		const trimmedFirstName = firstName.trim();
		const trimmedLastName = lastName.trim();

		if (!trimmedFirstName) {
			return DEFAULT_ANONYMOUS_NAME;
		}

		const lastInitial = trimmedLastName ? ` ${trimmedLastName[0]}` : '';

		return `${trimmedFirstName}${lastInitial}`;
	}, [firstName, lastName]);
};
